import PLAT_TYPE_MENU_TOOL from "./plattypemenu-const";
import COMMON_CONSTS from "./common-const";

export default {
  ...PLAT_TYPE_MENU_TOOL,
  ...COMMON_CONSTS,
};
